module.exports = __webpack_public_path__ + "img/door_opening.fb4f4355.gif";